import React from 'react';
export function GuaranteeSection() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-79">
      <div className="bg-[var(--card)] border border-[var(--border)] rounded-[20px] p-8 text-center" data-id="element-80">
        <div className="text-[56px] mb-4" data-id="element-81">🛡️</div>

        <h2 className="text-[clamp(24px,6vw,36px)] font-extrabold leading-tight" data-id="element-82">
          Mi Garantía "Cero Riesgo" de{' '}
          <span className="text-[var(--accent)]" data-id="element-83">30 Días</span>
        </h2>

        <div className="h-[3px] w-10 bg-[var(--accent)] mx-auto mt-3.5 mb-5" data-id="element-84" />

        <p className="text-white text-[16px] leading-relaxed" data-id="element-85">
          Si aplicas el sistema en tus próximas citas y sientes que no te dio la
          claridad absoluta que prometimos, envíame un correo. Te devolveremos
          el 100% de tus $17 USD. Sin preguntas, sin formularios complicados y
          sin drama. El riesgo es mío, no tuyo.
        </p>
      </div>
    </section>;
}